import React from "react";
import tw, { css } from "twin.macro";
//prettier-ignore
import { FaCheckCircle, FaChevronRight, FaPlus, FaLongArrowAltRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import basicplan from "../../images/basicplan.svg";
import standardplan from "../../images/standardplan.svg";
import plusplan from "../../images/pluswhite.svg";
// import video from "../../images/video.mp4";
import premiumplan from "../../images/premiumplan.svg";
import carimage from "../../images/carimage.png";
import carimage1 from "../../images/carimage1.png";
import covid19 from "../../images/covid-19.png";
import SubscribeSection from "../../components/SubscribeSection/SubscribeSection";
import { motion } from "framer-motion";
import ReactTooltip from 'react-tooltip'
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import MessageIcon from '@mui/icons-material/Message';
import CallIcon from '@mui/icons-material/Call';
import MailIcon from '@mui/icons-material/Mail';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const video = "https://glint-website.s3.ap-south-1.amazonaws.com/video.mp4"

// function ServiceCheckBox({ service, handleServiceChange }) {
//   return (
//     <div>
//       <div
//         css={[
//           tw`bg-primary p-2 sm:mx-6 mx-3 mt-6 flex justify-center items-center hover:bg-secondary hover:cursor-pointer`,
//           css`
//             border-width: 20px;
//             border-color: #171717;

//             &:hover {
//               border-color: #ffc043;
//             }

//             @media screen and (max-width: 639px) {
//               border-width: 16px;
//             }
//           `,
//         ]}
//         onClick={() => handleServiceChange(service)}
//       />
//       <p tw="text-gray-200 text-sm text-center font-medium">{service}</p>
//     </div>
//   );
// }

function PlanPricing({ plan }) {
  return (
    <div tw="my-12">
      <p tw="text-gray-500 text-lg font-medium">OEMs Cost</p>
      <p tw="text-gray-500 text-2xl font-bold">
        ₹<span tw="text-4xl">{plan.oemPrice}</span>
      </p>
      <p tw="text-gray-500 text-lg font-medium">Glint cost</p>
      <div tw="xl:flex">
        <p tw="text-primary text-6xl font-extrabold">
          ₹<span tw="text-8xl">{plan.glintPrice}</span>
        </p>
        <p tw="text-gray-500 xl:m-4 lg:my-4">
          for a monthly alternate day subscription plan.
        </p>
      </div>
    </div>
  );
}

function HomeSection({
  topLine,
  heading1,
  heading2,
  description,
  buttonLabel,
  subHeading1,
  subHeading2,
  description2a,
  description2b,
  cardContent1,
  cardContentLink1,
  cardContent2,
  cardContentLink2,
  cardContent3,
  cardContent4,
  services,
  description4,
  description5,
  description6,
  plans,
  featureList2,
  faqs,
  faqAnswers,
}) {
  const [plan, setPlan] = React.useState({
    plan: "Glint Standard",
    oemPrice: "2,554",
    glintPrice: "699",
  });
  const [faqAnswer, setFaqAnswer] = React.useState({
    index: "",
    answer: "",
  });
  const subscriptionPlan = React.useRef();

  // const [service, setService] = React.useState("");

  const buttonVariants = {
    hover: {
      scale: 1.2,
      originX: 0,
    },
  };

  // function handleServiceChange(service) {
  //   setService(service);
  // }

  function handlePlanChange(plan) {
    if (plan === "Glint Basic") {
      setPlan({
        plan: "Glint Basic",
        oemPrice: "2,454",
        glintPrice: "599",
      });
    } else if (plan === "Glint Standard") {
      setPlan({
        plan: "Glint Standard",
        oemPrice: "2,554",
        glintPrice: "699",
      });
    } else if (plan === "Glint Plus") {
      setPlan({
        plan: "Glint Plus",
        oemPrice: "2,754",
        glintPrice: "799",
      });
    } else if (plan === "Glint Premium") {
      setPlan({
        plan: "Glint Premium",
        oemPrice: "2,954",
        glintPrice: "999",
      });
    }
  }

  function handleFaqOpen(index) {
    setFaqAnswer({
      index: index,
      answer: faqAnswers[index],
    });
  }

  const [show,setShow] = React.useState(true);

  return (
    <>
    

    {/* With HUBSPOT */}
      <div tw=" relative bg-secondary h-[70vh] md:h-[80vh]  w-[100vw] overflow-hidden">
        { show ?
        <div tw="flex flex-col items-center">
          <div tw="absolute top-20 z-40 sm:w-auto w-4/5">
            <motion.p
              initial={{ x: -1500 }}
              animate={{ x: 0 }}
              transition={{
                ease: "easeIn",
                duration: 0.5,
              }}
              tw=" text-primary text-xl font-semibold"
            >
              {topLine}
            </motion.p>
            <motion.h1
              initial={{ x: -1500 }}
              animate={{ x: 0 }}
              transition={{
                ease: "easeIn",
                duration: 0.5,
                delay: 0.5,
              }}
              css={[
                tw`text-white lg:text-9xl sm:text-7xl text-6xl font-black`,
                css`
                  line-height: 4rem;

                  @media screen and (max-width: 320px) {
                    font-size: 3rem;
                    line-height: 3rem;
                  }

                  @media screen and (max-width: 767px) {
                    line-height: 3rem;
                  }
                `,
              ]}
            >
              {heading1}
            </motion.h1>
            <motion.h1
              initial={{ x: -1750 }}
              animate={{ x:0 }}
              transition={{
                ease: "easeIn",
                duration: 0.5,
                delay: 1,
              }}
              css={[
                tw`text-primary lg:text-9xl sm:text-7xl text-6xl font-black sm:pb-4 sm:ml-36 sm:mt-0 mt-4`,
                css`
                  line-height: 10rem;

                  @media screen and (max-width: 320px) {
                    font-size: 3rem;
                    line-height: 3rem;
                  }

                  @media screen and (max-width: 767px) {
                    line-height: 3rem;
                  }
                `,
              ]}
            >
              {heading2}
            </motion.h1>
          </div> 
      

          <video tw="relative opacity-50 w-auto min-w-full min-h-full max-w-none" 
          onContextMenu={e => e.preventDefault()} preload="auto" controlsList="nodownload noaudio" 
          disablePictureInPicture disableRemotePlayback playsInline autoPlay loop muted >
            <source src={video} type="video/mp4" />               
            </video>

          <div tw="absolute z-40 top-2/3 md:top-[70%] md:flex md:justify-between md:items-center bg-white md:h-32 h-24 rounded-lg lg:w-1/2 w-4/5">
            <p tw="md:text-xl md:w-3/4 md:font-bold font-semibold md:p-8 p-2">
              {description}
            </p>
            <a
               onClick={()=>setShow(!show)}
              tw="flex justify-center items-center bg-primary md:text-2xl text-lg font-extrabold text-center md:p-4 p-2 md:h-full hover:scale-110 hover:text-black cursor-pointer"
            >
              Subscribe now
            </a>
          </div>

        </div> 
        :  
        <>
        <motion.div
        animate={{ rotateY: -360 }}
        transition={{
          ease: "easeOut",
          duration: 0.25,          
        }} tw="h-auto"> 

          <img src={covid19} tw="top-0 absolute w-auto min-w-full h-full max-w-none" />
   
          <div tw="bg-gradient-to-r from-secondary to-tertiary opacity-90 relative h-full">
            <button data-tip="React-tooltip"  onClick={()=>setShow(!show)} tw="ml-[4vh] md:ml-[12vh] z-40 hover:scale-110 mt-2 bg-primary text-secondary md:text-2xl text-lg font-extrabold text-center md:p-2 p-2 md:h-full h-2/4">
                X
            </button>
          <ReactTooltip place="right" type="light" backgroundColor='#ffc043' textColor="#1b1b1b" tw="font-bold" effect="solid">
            Close
          </ReactTooltip>
            <SubscribeSection name="Home"/> 
          </div>      
        </motion.div>
        
        </>
        }
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ ease: "easeIn", delay: 1.5 }}
      >
        <div tw="bg-primary">
          <div
            tw="container mx-auto 
              xl:px-24 md:py-32 py-10 
              md:grid md:grid-cols-2 md:gap-4 
              justify-items-center"
          >
            <div tw="xl:w-3/5 lg:w-2/3 lg:px-0 px-10">
              <div tw="bg-secondary w-8 h-3 mb-2" />
              <h2 tw="text-secondary xl:text-4xl sm:text-2xl text-lg font-black">
                {subHeading1}
              </h2>
              <h2 tw="text-secondary xl:text-4xl sm:text-2xl text-lg font-black">
                {subHeading2}
              </h2>
              <p tw="text-black mt-4">{description2a}</p>
              <p tw="text-black mt-4">{description2b}</p>
            </div>
            <div tw="relative">
              <div
                css={[
                  tw`bg-tertiary rounded-t-lg`,
                  css`
                    @media screen and (max-width: 767px) {
                      display: none;
                    }

                    @media screen and (min-width: 768px) {
                      width: 240px;
                      height: 140px;
                    }

                    @media screen and (min-width: 1024px) {
                      width: 340px;
                      height: 215px;
                    }

                    @media screen and (min-width: 1280px) {
                      width: 440px;
                      height: 290px;
                    }
                  `,
                ]}
              />
              <img
                src={carimage1}
                alt="Cleaning your car glasses."
                css={[
                  tw`absolute top-10 left-10`,
                  css`
                    @media screen and (max-width: 767px) {
                      display: none;
                    }
                  `,
                ]}
              />
            </div>
          </div>
        </div>
        <div tw="bg-secondary">
          <div
            tw="container mx-auto 
              xl:px-24 sm:px-10 lg:py-20 py-12
              lg:grid lg:grid-cols-2 lg:gap-4 
              flex flex-col lg:items-start items-center justify-items-center"
          >
            <div tw="lg:w-full w-4/5">
              <div tw="sm:p-4 p-2 lg:w-3/5 xl:w-2/5 h-48 border-2 border-primary">
                <p tw="text-white px-2 mb-8 text-lg font-semibold">
                  {cardContent1}
                </p>

                <motion.p variants={buttonVariants} whileHover="hover">
                  <Link to="/process" tw="text-primary px-2 font-bold hover:text-primary">
                    {cardContentLink1}
                  </Link>
                </motion.p>
              </div>
              <div tw="sm:p-4 p-2 lg:w-3/5 xl:w-2/5 h-48 bg-primary 2xl:ml-96 xl:ml-72 lg:ml-36 xl:mt-0 mt-4">
                <p tw="text-black px-2 mb-8 text-lg font-semibold">
                  {cardContent2}
                </p>
                <motion.p
                  variants={buttonVariants}
                  whileHover="hover"
                  tw="text-secondary px-2 font-bold hover:cursor-pointer"
                  onClick={() => {
                    subscriptionPlan.current.scrollIntoView({
                      behavior: "smooth",
                    });
                  }}
                >
                  {cardContentLink2}
                </motion.p>
              </div>
            </div>
            <div tw="lg:w-full w-4/5">
              <div tw="sm:p-4 p-2 lg:w-3/5 xl:w-2/5 h-48 border-2 border-primary lg:mt-0 mt-4">
                <p tw="text-white px-2 mb-8 text-lg font-semibold">
                  {cardContent3}
                </p>
              </div>
              <div tw="sm:p-4 p-2 lg:w-3/5 xl:w-2/5 h-48 bg-primary 2xl:ml-96 xl:ml-72 lg:ml-36 xl:mt-0 mt-4">
                <p tw="text-black px-2 mb-8 text-lg font-semibold">
                  {cardContent4}
                </p>
              </div>
            </div>
          </div>
          <div tw="container mx-auto xl:px-48 sm:px-10 flex flex-col xl:items-end items-center">
            <p tw="text-white xl:text-7xl text-5xl font-extrabold">
              all at your
            </p>
            <p tw="text-primary xl:text-7xl text-5xl font-extrabold">
              Doorstep.
            </p>
          </div>
        </div>
        {/* <div tw="bg-secondary">
          <div
            tw="container mx-auto 
              xl:px-24 sm:px-10 lg:py-20 py-12
              lg:grid lg:grid-cols-2 lg:gap-4
              justify-items-center
              flex flex-col items-center"
          >
            <div tw="md:w-3/4 sm:w-1/2 w-4/5 mb-8">
              {featureList.map((list, index) => (
                <div tw="flex items-center">
                  <FaStarOfLife tw="flex-shrink-0 text-primary text-lg" />
                  <li tw="mx-4 text-gray-200 text-base font-medium list-none">
                    {list}
                  </li>
                </div>
              ))}
            </div>

            <div tw="lg:w-3/5 w-4/5 sm:p-8 p-4 lg:mt-0 mt-8 border-2 border-primary">
              <p tw="text-white px-4 mb-8 text-lg font-semibold">
                {cardContent3}
              </p>
              <motion.p variants={buttonVariants} whileHover="hover">
                <Link to="/process" tw="text-primary px-4 font-bold">
                  {cardContentLink3}
                </Link>
              </motion.p>
            </div>
          </div>
        </div> */}
        <div tw="bg-secondary">
          <div tw="container mx-auto xl:px-12 py-12" ref={subscriptionPlan}>
            <div
              tw="bg-tertiary 
                  xl:px-12 sm:px-8 px-2 py-10 
                  lg:grid lg:grid-cols-2 lg:gap-4 
                  justify-items-center"
            >
              <div tw="sm:p-8 p-2">
                <div tw="bg-primary w-8 h-3 mb-2" />
                <p tw="text-white sm:text-5xl text-2xl font-black">
                  showroom <span tw="text-primary">quality</span>, at a fraction
                  of the <span tw="text-primary">price.</span>
                </p>
                <div tw="flex">
                  {plan.plan === "Glint Standard" ? (
                    <img
                      src={standardplan}
                      alt="Glint Standard monthly car cleaning subscription at ₹699 with 12 washes in a month."
                      tw="mt-24 mb-16 sm:mr-8 mr-2 w-3/4 h-1/2"
                    />
                  ) : plan.plan === "Glint Plus" ? (
                    <img
                      src={plusplan}
                      alt="Glint Plus monthly car cleaning subscription at ₹799 with 12 washes and an Interior in a month."
                      tw="mt-24 mb-16 sm:mr-8 mr-2 w-3/4 h-1/2"
                    />
                  ) : plan.plan === "Glint Premium" ? (
                    <img
                      src={premiumplan}
                      alt="Glint Premium monthly car cleaning subscription at ₹999 with 12 washes, 2 interiors, and 1 wax coating."
                      tw="mt-24 mb-16 sm:mr-8 mr-2 w-3/4 h-1/2"
                    />
                  ) : (
                    <img
                      src={carimage}
                      alt="Car Outline"
                      tw="mt-24 mb-16 sm:mr-8 mr-2 w-1/2 h-1/2"
                    />
                  )}
                </div>

                <p tw="text-primary sm:text-xl text-sm mt-2 font-semibold">
                  3 washes/week x 4 weeks
                </p>
                <p tw="text-gray-200 sm:text-base text-sm mt-2 font-semibold">
                  <span tw="text-lg text-primary">Schedule(s):</span>
                  <br />
                  Monday / Wednesday / Friday
                  <br />
                  Tuesday / Thursday / Saturday
                </p>
              </div>
              <div tw="sm:p-8 sm:py-0 mt-10 py-4 px-2 md:w-5/6">
                <p tw="text-white whitespace-normal mb-4">{description4}</p>
                <p tw="text-white whitespace-normal mb-4">{description5}</p>
                <p tw="text-white whitespace-normal mb-4">{description6}</p>
                <div tw="mt-4 w-40 h-2 bg-primary" />
                {plan && <PlanPricing plan={plan} />}
                {plans.map((p) => (
                  <motion.li
                    whileHover={{
                      scale: 1.2,
                      originX: 0,
                    }}
                    css={[
                      tw`w-max text-gray-400 text-sm font-medium mb-2 list-none 
                          hover:text-primary hover:cursor-pointer`,
                      p === plan.plan &&
                        tw`text-primary font-semibold list-none border-b-2 border-primary`,
                    ]}
                    onClick={() => handlePlanChange(p)}
                  >
                    {p}
                  </motion.li>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div tw="bg-white">
          <div tw="container mx-auto xl:px-24 px-6 py-12 grid grid-cols-1 gap-2">
            <div tw="lg:justify-self-end">
              <div tw="grid grid-cols-1">
                <div tw="lg:w-1/2 justify-self-center">
                  <p tw="sm:text-lg font-medium">
                    Not interested in a subscription? Check out our prepaid
                    packages.
                  </p>
                  <Link to="/pricing" tw="text-primary font-medium hover:text-primary" >
                    Prepaid Packages
                  </Link>
                </div>
              </div>
            </div>
            <div tw="flex justify-self-center sm:my-20 my-10">
              <p tw="text-gray-500 lg:text-5xl sm:text-3xl font-medium">
                Want to decide your own time?{" "}
                <span tw="text-primary">Okay.</span>
              </p>
            </div>
            <div tw="justify-self-center lg:w-3/5">
              <p tw="text-gray-500 text-lg font-medium">
                Features designed for your car’s needs and convenience:
              </p>
              <div tw="grid lg:grid-cols-2 gap-2 my-6">
                {featureList2.map((fl) => (
                  <div tw="flex items-center">
                    <FaCheckCircle tw="flex-shrink-0 text-gray-600 text-lg" />
                    <li tw="mx-4 text-gray-600 text-lg font-medium list-none">
                      {fl}
                    </li>
                  </div>
                ))}
              </div>
              {/* <Link to="/process" tw="text-primary font-medium">
                {cardContentLink3}
              </Link> */}
            </div>
          </div>
        </div>
        <div tw="bg-secondary">
          <div tw="container mx-auto xl:px-24 md:px-12 py-12 flex">
            <div tw="relative">
              <div
                css={[
                  tw`bg-primary rounded-t-lg`,
                  css`
                    @media screen and (max-width: 767px) {
                      display: none;
                    }

                    @media screen and (min-width: 768px) {
                      width: 450px;
                      height: 250px;
                    }

                    @media screen and (min-width: 1024px) {
                      width: 600px;
                      height: 300px;
                    }

                    @media screen and (min-width: 1280px) {
                      width: 800px;
                      height: 400px;
                    }
                  `,
                ]}
              />
              <img
                src={covid19}
                alt="Glint Car Care Partners Detailing a car exterior."
                css={[
                  tw`bg-red-500 absolute top-14 left-14`,
                  css`
                    @media screen and (max-width: 767px) {
                      display: none;
                    }
                  `,
                ]}
              />
            </div>
            <div tw="flex flex-col justify-between sm:mt-20">
              <p tw="text-white sm:text-2xl lg:text-2xl font-extrabold sm:ml-16 mx-10">
                We also offer{" "}
                <span tw="text-primary sm:text-xl lg:text-4xl font-extrabold">
                  add-on detailing services.
                </span>
              </p>
              <Link
                to="/pricing"
                tw="text-white hover:text-white sm:text-4xl text-lg font-extrabold sm:ml-16 mx-10"
              >
                Ask us.
              </Link>
            </div>
          </div>
        </div>
        <div tw="bg-secondary">
          <div tw="container mx-auto xl:px-24 sm:py-12 py-6 lg:flex items-center">
            <div tw="sm:m-14 m-4 divide-y divide-primary lg:w-1/2">
              {faqs.map((faq, index) => (
                <div
                  key={`${index}-d`}
                  tw="py-4 flex justify-between items-center"
                >
                  <li key={`${index}-f`} tw="text-gray-300 list-none">
                    {faq}
                  </li>
                  {faqAnswer.answer !== "" && faqAnswer.index === index ? (
                    <FaChevronRight
                      key={`${index}-i`}
                      tw="text-primary hover:cursor-pointer"
                    />
                  ) : (
                    <FaPlus
                      key={`${index}-i`}
                      tw="text-primary hover:cursor-pointer"
                      onClick={() => handleFaqOpen(index)}
                    />
                  )}
                </div>
              ))}
            </div>
            {faqAnswer.answer && (
              <div tw="bg-gray-300 lg:w-1/3 lg:h-1/2 p-10">
                <p>{faqAnswer.answer}</p>
              </div>
            )}
          </div>
        </div>
        <div tw="bg-white ">
          <div tw="container mx-auto pt-10 pb-6 flex flex-col">
            <div tw="w-max self-center ">
              <h1 tw="text-gray-600 md:text-7xl sm:text-5xl text-3xl font-black ">
                look good,
              </h1>
              <h1 tw="text-primary md:text-7xl sm:text-5xl text-3xl font-black ml-24 pb-4">
                feel good.
              </h1>             
              <a
                href="http://wa.me/919384016213?text=Hi, I would like to Subscribe"
                tw="text-gray-600 font-semibold hover:text-gray-600"
              >
                Learn more about{" "}
                <span tw="text-primary font-black">glint.</span>
                </a>
            </div>
          </div>
        </div>
        <div tw="w-[100%] flex items-center justify-center p-5">
              <div tw="w-[80%] border-t border-secondary">
                <div tw="flex mt-2 font-bold justify-evenly">
                  <div tw="flex lg:flex-row flex-col ">
                    <span tw="ml-3"><MessageIcon/> Contact Us</span>
                    <span tw="ml-3"><CallIcon/> +91 9384016213</span>
                    <a href="mailto:support@goglint.in" tw="ml-3 hover:text-primary"><MailIcon/> support@goglint.in</a>
                    <span tw="ml-3"><HeadphonesIcon/> (Mon-Sat) 9AM-7PM & (Sun) 11AM-6PM</span>
                    <div tw="flex flex-row justify-evenly">
                    <a tw="hover:scale-110 ml-3" href="https://www.facebook.com/goglint/" target="_blank"><FacebookIcon tw="text-[#4267B2]"/></a>
                    <a tw="hover:scale-110 ml-3" href="https://www.instagram.com/goglint.in/?hl=en" target="_blank"><InstagramIcon tw="text-[#bc2a8d]"/></a>
                    <a tw="hover:scale-110 ml-3" href="https://www.youtube.com/channel/UCkGX-2Cf_zD57zA_-pN7yGA/featured" target="_blank"><YouTubeIcon tw="text-red-500"/></a>   
                    <a tw="hover:scale-110 ml-3" href="https://www.linkedin.com/company/goglint/" target="_blank"><LinkedInIcon tw="text-[#0072b1]"/></a>   
                    </div>
                  </div> 
                </div>
              </div>
        </div>
      </motion.div>
    </>
  );
}

export default HomeSection;
